
namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class WorkflowInstanceDialog extends SiteEntityDialog<WorkflowInstanceRow, any> {
        protected getFormKey() { return WorkflowInstanceForm.formKey; }
        protected getIdProperty() { return WorkflowInstanceRow.idProperty; }
        protected getLocalTextPrefix() { return WorkflowInstanceRow.localTextPrefix; }
        protected getNameProperty() { return WorkflowInstanceRow.nameProperty; }
        protected getService() { return WorkflowInstanceService.baseUrl; }

        protected form = new WorkflowInstanceForm(this.idPrefix);

        constructor() {
            super();

            $(window).on('resize.' + this.uniqueName, () => this.arrange());
        }

        destroy() {
            $(window).off('.' + this.uniqueName);
            super.destroy();
        }

        protected arrange() {
            super.arrange();
            var availHeight = $(window).height() - 290;
            this.form.Documents.element.css('height', Math.max(150, availHeight) + 'px').trigger('layout');
            this.form.Tasks.element.css('height', Math.max(150, availHeight) + 'px').trigger('layout');
        }

        protected updateInterface() {
            super.updateInterface();

            this.cloneButton.hide();
            if (this.entity.WorkflowClass1 != "MX:DQ TEST RESULT") {
                this.toolbar.findButton('edit-button').hide();
            }
            else {
                if (!this.isViewMode) {
                    makeReadOnly(this.byId('Form'));
                    Serenity.EditorUtils.setReadOnly(this.form.C1, false);
                    Serenity.EditorUtils.setReadOnly(this.form.D1, false);
                    Serenity.EditorUtils.setReadOnly(this.form.StatusCode, false);
                    Serenity.EditorUtils.setReadOnly(this.form.Txt3, false);
                }
                this.form.Txt3.element.css('height', '150px');
            }

            this.toolbar.findButton('reject-button').toggle(this.entity.StatusCode === "PENDING");
            this.deleteButton.hide();

            if (this.entity.StatusCode !== "PENDING")
                this.toolbar.element.hide();
        }

        protected getToolbarButtons() {
            var buttons = super.getToolbarButtons();
            buttons.push({
                title: "Reject",
                cssClass: 'reject-button',
                icon: 'fa-times',
                onClick: () => {
                    Q.confirm('Reject this workflow instance?', () => {
                        WorkflowInstanceService.Update({
                            EntityId: this.entityId,
                            Entity: {
                                StatusCode: 'REJECTED'
                            }
                        },
                            response => {
                                Serenity.SubDialogHelper.triggerDataChange(this);
                                this.dialogClose();
                            });
                    });
                }
            });
            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            var workflow = WorkflowRow.getLookup().itemById[(this.entity || {}).WorkflowCode];

            this.propertyGrid.enumerateItems((item, editor) => {
                if (WorkflowInstanceNamedFields[item.name]) {
                    if (workflow && workflow[item.name + "Name"]) {
                        editor.getGridField().show()
                            .find('label.caption').text(titleize(workflow[item.name + "Name"]));
                    }
                    else if (workflow) {
                        editor.getGridField().hide();
                    }
                }
            });

            Workflow.replaceWithJsonViewer(this.form.Properties.element, this.entity.Properties);

            this.form.Documents.workflowInstanceId = this.entityId;
            this.form.Tasks.workflowInstanceId = this.entityId;
        }
    }

    export function replaceWithJsonViewer(textArea: JQuery, json: string) {
        if (window['JSONTree']) {
            var jsonViewer = textArea.next('.json-viewer');
            if (!jsonViewer.length) {
                jsonViewer = $('<div class="json-viewer">').insertAfter(textArea);
            }

            textArea.hide();

            jsonViewer.html('');

            var data;
            if (json) {
                try {
                    data = JSON.parse(json);
                } catch (e) { }
            }

            if (data != null)
                jsonViewer.html(window['JSONTree'].create(data));
        }
    }
}